export default __webpack_public_path__ + "static/media/logo-sipat-nexa-orange.4c7aefd0.png";